import { render, staticRenderFns } from "./activity-collect-fragment.vue?vue&type=template&id=270d608d&scoped=true&"
import script from "./activity-collect-fragment.vue?vue&type=script&lang=js&"
export * from "./activity-collect-fragment.vue?vue&type=script&lang=js&"
import style0 from "./activity-collect-fragment.vue?vue&type=style&index=0&id=270d608d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270d608d",
  null
  
)

export default component.exports